<template>
  <div class="header-wrap relative">
    <div class="container flex justify-start lg:justify-center">
      <section class="text-white w-full md:w-1/2 lg:w-2/5 pt-20">
        <header class="px-6 lg:px-16 xxl:px-12">
          <h2>{{ title || 'Wat is mijn Superkracht ?' }}</h2>
          <div class="text-sm mt-1">
            <span v-if="$route.path.includes('/ouders')">Voor ouders</span>
            <span v-else>Voor begeleiders</span>
          </div>
        </header>
        <hr class="my-2 text-secondary-lighter">
        <main class="relative z-50 px-6 lg:px-12 text-sm leading-normal">
          <div v-if="content" class="content lg:pl-4 lg:pr-16 xxl:px-0 prose" v-html="content"/>
          <div v-else>
            <p>
              Mijn Superkracht is een online communicatieomgeving, speciaal ontwikkeld voor individuele begeleiding met
              Remedial Teaching.
              Een begeleider kan veilig online communiceren en opdrachten geven aan een leerling en de leerling kan deze
              dan op zijn/haar gemak thuis maken.
            </p>
            <p>
              Ook is het een netwerk van aangesloten begeleiders, die samen een netwerk vormen waar je al je vragen aan
              kunt stellen.
            </p>
          </div>
        </main>
      </section>
    </div>
    <img
      src="~/assets/img/characters/character-side.svg"
      alt=""
      aria-hidden="true"
      class="absolute character-left hidden lg:block"
    >
    <img
      src="~/assets/img/shapes/circle-filled.svg"
      alt=""
      aria-hidden="true"
      class="absolute circle-left hidden lg:block"
    >
    <img
      src="~/assets/img/characters/character-front.svg"
      alt=""
      aria-hidden="true"
      class="absolute character-right hidden md:block"
    >
    <img src="~/assets/img/shapes/circle-filled.svg" alt="" aria-hidden="true" class="absolute circle-right">
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.header-wrap {
  @apply overflow-hidden py-10;
  z-index: 60;
  min-height: 500px;
  background-image: linear-gradient(to right, theme('colors.secondary.default'), theme('colors.secondary.default') 10%, theme('colors.secondary.light') 90%);

  .character-left {
    z-index: 2;
    bottom: 0;
    left: 5%;
    @screen xl {
      left: 10%;
    }
    transform: scale(1.3);
  }

  .circle-left {
    z-index: 1;
    bottom: -12%;
    left: -5%;
    width: 450px;
    @screen xl {
      bottom: -25%;
      left: 1%;
    }
  }

  .character-right {
    z-index: 2;
    bottom: -5%;
    right: 0;
    @screen xl {
      right: 13%;
    }
  }

  .circle-right {
    z-index: 1;
    bottom: -60%;
    right: 0;
    width: 450px;
    @screen md {
      bottom: -12%;
      right: -5%;
    }
    @screen xl {
      bottom: -15%;
      right: 5%;
    }
  }

  .prose {
    @apply text-white;
  }
}
</style>
